import { createFileRoute } from '@tanstack/react-router';
import { ContractsCard } from './-components/ContractsCard';

export const Route = createFileRoute('/_auth/dashboard/_layout/contracts')({
  component: RouteComponent,
  context: () => {
    return {
      getBreadcrumbData: () => ({
        id: null,
        translationKey: null,
      }),
    };
  },
  head: () => {
    return {
      meta: [
        {
          title: 'Contracts - OPAZ E-Service Portal',
        },
      ],
    };
  },
});

function RouteComponent() {
  return <ContractsCard />;
}
